/* eslint-disable no-useless-escape */
// import moment from "moment/moment";
import { EncryptStorage } from "encrypt-storage";
import { Notify } from "Component/Notify";
import CryptoJS from "crypto-js";
import moment from "moment";

//fungsi membatasi jumlah karakter yang tampil
//konversi KB ke MB
export const licenseNumber = "X7K8PMN3J2Q9Z5A8L4TPYF7B1";
const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);

export const characterLimit = (text, limitText) => {
  const truncatedText =
    text?.length > limitText ? `${text?.slice(0, limitText)}...` : text;
  return truncatedText;
};

//konversi KB ke MB
export const convertKBtoMB = (kb, numberBehindComa) => {
  return (kb / 1024).toFixed(numberBehindComa);
};

export const bytesToMB = (bytes) => (bytes / (1024 * 1024)).toFixed(2);

export const formatFileSize = (size) => {
  try {
    if (typeof size !== "number" || size < 0) throw new Error("Invalid size");
    if (size < 1024) return `${size} B`;
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    return `${(size / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  } catch {
    return "0 B";
  }
};

export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Tambah 1 karena bulan dimulai dari 0
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const roundToTwoDecimals = (num) => {
  return Math.floor(num * 100);
};

//fungsi menampilkan image biner
export const displayBinaryImage = (image) => {
  const base64Format = "data:image/jpeg;base64,";
  const defaultImage = "/defaultImage.png";

  return image ? base64Format + image : defaultImage;
};

//fungsi untuk menampilkan date dari api
export const formatDisplayDate = (data) => {
  const inputDate = data;
  const date = moment.utc(inputDate);
  return date.format("D MMM YYYY");
};

export const formatDisplayDate2 = (data) => {
  const inputDate = data;
  const date = moment.utc(inputDate);
  return date.format("D-MM-YYYY");
};
export const formatTimestamp = (data) => {
  const inputDate = data;
  const date = moment.utc(inputDate);
  return date.format("DD MMM yyyy HH:mm");
};

export const formatDisplayDate3 = (data) => {
  const inputDate = data;
  const date = moment.utc(inputDate);
  return date.format("YYYY-MM-DD HH:mm:ss");
};

//fungsi untuk input date form
export const formatDateInput = (field) => {
  return moment(field).format("YYYY-MM-DD");
};

export const formatDateTimeInput = (field) => {
  return moment(field).format("YYYY-MM-DD HH:mm:ss");
};

//fungsi logout + menghapus data di local storage
export const handleLogout = () => {
  // const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  encryptStorage.clear();
  localStorage.clear();
  window.location.href = "/login";
};

// Fungsi pagination manual
export function paginate(array, pageNumber, pageSize) {
  const startIndex = pageNumber * pageSize; // Tidak ada -1, karena pageNumber dimulai dari 0
  const endIndex = startIndex + pageSize;
  return array.slice(startIndex, endIndex);
}

//fungsi untuk menghilangkan kutip
export const valueWithoutQuotes = (value) => {
  return value.replace(/['"]+/g, "");
};

export const handleArrayValue = (value) => {
  return value.replace(/[\[\]"]/g, "");
};

//fungsi untuk convert file ke base64
export const fileToBase64 = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};

export const isAllDataNotNull = async (body) => {
  for (const key in body) {
    if (body[key] === null || body[key] === undefined || body[key] === "") {
      return false;
    }
  }

  return true;
};

export const base64ToFile = (base64String, filename) => {
  const arr = base64String.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

export const dataURItoBlob = (dataURI) => {
  const byteString = atob(dataURI.split(",")[1]);
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
};

export const isoStringToDateInput = (isoString) => {
  if (!isoString) return "";
  return isoString.split("T")[0];
};

export const convertToISOString = (dateValue) => {
  if (!dateValue) return "";
  const localDate = new Date(dateValue);
  return localDate.toISOString();
};

export function capitalizeFirstLetter(string) {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1)?.toLowerCase();
}

let isErrorNotified = false;
let errorTimeout = null;

export const handleError = (error) => {
  const status = error?.response?.status;
  const message = error?.response?.data?.message || "Terjadi kesalahan";

  const showNotifyOnce = (title, description) => {
    if (isErrorNotified) return;
    isErrorNotified = true;
    Notify.error({ title, description, duration: 3000 });

    clearTimeout(errorTimeout);
    errorTimeout = setTimeout(() => {
      isErrorNotified = false;
    }, 1000); // Reset setelah 3 detik
  };

  const auth = () => {
    showNotifyOnce("Unauthorized", "Silakan login ulang");
    // redirect ke login jika perlu
  };

  if (status === 401) {
    auth();
    return;
  }

  switch (status) {
    case 400:
      showNotifyOnce("Gagal Menghapus Data", message);
      break;
    case 403:
      showNotifyOnce("Akses Ditolak", "Anda tidak memiliki akses.");
      break;
    case 404:
      showNotifyOnce(
        "Data Tidak Ditemukan",
        "Data yang Anda cari tidak tersedia atau mungkin sudah dihapus."
      );
      break;
    case 409:
      showNotifyOnce("Gagal Menghapus Data", message);
      break;
    case 500:
      showNotifyOnce(
        "Kesalahan Sistem",
        "Terjadi gangguan pada sistem. Silakan coba lagi nanti atau hubungi administrator."
      );
      break;
    default:
      showNotifyOnce(
        "Gangguan Sistem",
        "Kami mengalami kendala saat memproses permintaan Anda."
      );
  }
};
export const handleErrorGlobal = (error) => {
  Notify.error({
    title: "Gagal",
    description: error,
  });
};

export const handleWarning = (message) => {
  Notify.warning({
    title: "Peringatan",
    description: message,
  });
};

export const handleSuccess = (message) => {
  Notify.success({
    title: "Berhasil",
    description: message || "Berhasil",
  });
};

export const convertToIndonesianTime = (timestamp) => {
  if (!timestamp) return null;

  const date = new Date(timestamp);

  // Tambahkan offset WIB (GMT+7)
  const wibOffset = 7 * 60; // 7 jam dalam menit
  const localDate = new Date(date.getTime() + wibOffset * 60000);

  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, "0");
  const day = String(localDate.getDate()).padStart(2, "0");
  const hours = String(localDate.getHours()).padStart(2, "0");
  const minutes = String(localDate.getMinutes()).padStart(2, "0");
  const seconds = String(localDate.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const generateUUID = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
};

export const saveUUIDToLocalStorage = (uuid) => {
  const existingUUID = localStorage.getItem("userUUID");

  if (!existingUUID) {
    // Jika belum ada UUID, buat UUID baru dan simpan
    localStorage.setItem("userUUID", uuid);
    // console.log("UUID baru disimpan:", newUUID);
  } else {
    // Jika sudah ada UUID, jangan lakukan apa-apa
    console.log("UUID sudah ada di localStorage:", existingUUID);
  }
};

export const getUUIDFromLocalStorage = () => {
  const userUUID = localStorage.getItem("userUUID");

  if (userUUID) {
    // console.log("UUID ditemukan di localStorage:", userUUID);
    return userUUID;
  } else {
    // console.log("UUID tidak ditemukan di localStorage.");
    return null; // Jika UUID belum disimpan, kembalikan null
  }
};

export const getStartStop = (data) => {
  return new Promise((resolve) => {
    const checkData = () => {
      if (data?.length > 0) {
        const lastItem = data[data.length - 1]; // Ambil elemen terakhir
        if (lastItem?.text?.event) {
          resolve(lastItem.text.event); // Mengembalikan event jika ada
        }
      }
      // Jika data belum ada event, cek lagi setelah 100ms
      setTimeout(checkData, 100);
    };

    checkData(); // Mulai memeriksa data
  });
};
